import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import { ConfirmationDialog } from 'components'

import theme from 'theme'

const LinkConfirmationDialog = ({
  open,
  setOpen,
  privacyPolicy,
  loading = false,
  onConfirm = () => {},
}) => (
  <ConfirmationDialog
    open={open}
    setOpen={setOpen}
    loading={loading}
    accentColor={theme.palette.primary.main}
    text={
      <Box textAlign="center">
        <Typography variant="h4" gutterBottom>
          Vincular este documento como evidência?
        </Typography>
        <Typography variant="body1">
          O documento passará a constar como evidência deste controle.
        </Typography>
        <Typography variant="body1">
          Isso pode levar alguns segundos.
        </Typography>
      </Box>
    }
    showConfirmBox
    confirmDotColor={theme.palette.primary.main}
    // Com o identificador porque documentos gerados do mesmo modelo podem ter títulos idênticos, e a
    // confirmação é o último ponto em que o usuário consegue perceber que escolheu o documento errado.
    confirmItem={`${privacyPolicy?.title} · ID ${privacyPolicy?.id}`}
    textButton="Vincular"
    textButtonCancel="Cancelar"
    actionAcceptButton={onConfirm}
  />
)

LinkConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  privacyPolicy: PropTypes.object,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func,
}

export default LinkConfirmationDialog
